// routes
import React, { useEffect } from "react";
import Router from './routes';
// theme
import ThemeConfig from './theme';
import GlobalStyles from './theme/globalStyles';


// components
import ScrollToTop from './components/ScrollToTop';
import { BaseOptionChartStyle } from './components/charts/BaseOptionChart';
import { encryptStorage, setItemInL } from './CustomStorage';
import { APP_CONSTANTS, } from "./URLConstants";
import { useAuth } from './components/customContextProviders/AuthContext'







export default function App() {

  const { getAppLevelSettings, sessionUserData, getAudioCubeOrganizationTerritories } = useAuth()


  useEffect(() => {

    if (encryptStorage.getItem(APP_CONSTANTS.L_KEY_OF_USER_LOGGEDIN_STATUS) === undefined)
      setItemInL(APP_CONSTANTS.L_KEY_OF_USER_LOGGEDIN_STATUS, false)

    if (encryptStorage.getItem(APP_CONSTANTS.L_KEY_OF_P_DASHBOARD) === undefined) {
      setItemInL(APP_CONSTANTS.L_KEY_OF_P_DASHBOARD, "SOUNDBOX")
        }
    

    if (process.env.NODE_ENV === 'production') {
      console.log = function () { };
    }

    const isAuthenticated = encryptStorage.getItem(APP_CONSTANTS.L_KEY_OF_USER_LOGGEDIN_STATUS);

    if (isAuthenticated) {
      getAppLevelSettings()
      getAudioCubeOrganizationTerritories(sessionUserData?.user?.organization?.id)
    }

  }, []);



  return (
    <ThemeConfig>
      <ScrollToTop />
      <GlobalStyles />
      <BaseOptionChartStyle />
      <Router />
    </ThemeConfig>
  );
}
